import React from "react";
import StackedProgressBar from "components/customs/stacked-progress-bar";
import { getFormattedNumber } from "utility/helpers";
import styled from "styled-components";

const Container = styled.div`
  margin-left: 20px;
  margin-right: 20px;
`;

const StackedProgressBarContainer = styled.div`
  margin-bottom: 1.5rem;
  margin-top: 1.5rem;
`;

const MatrixContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 1.5rem;

  h6 {
    margin-bottom: 0;
  }
`;

const TotalAmountText = styled.h6`
  font-weight: bold;
  margin-left: 0.25rem;
`;

const EndorsementsTab = ({ projects, totalBudget }) => {
  return (
    <Container>
      <div>
        <StackedProgressBarContainer>
          <StackedProgressBar data={projects} />
        </StackedProgressBarContainer>

        <MatrixContainer>
          <h6>{"Total Amount Endorsed:"}</h6>
          <TotalAmountText>{getFormattedNumber(totalBudget)}</TotalAmountText>
        </MatrixContainer>
      </div>
    </Container>
  );
};

export default EndorsementsTab;
